export default __webpack_public_path__ + "static/media/stina-new.2649e273.gif";